// History API mini router (no dependency). 04-web §1.4.
export type RouteHandler = (params: Record<string, string>, root: HTMLElement) => void | Promise<void>;

interface Route {
  pattern: RegExp;
  keys: string[];
  handler: RouteHandler;
}

const routes: Route[] = [];
let notFound: RouteHandler = (_p, root) => {
  root.textContent = "404";
};

export function route(path: string, handler: RouteHandler): void {
  const keys: string[] = [];
  const pattern = new RegExp(
    "^" +
      path.replace(/:[^/]+/g, (m) => {
        keys.push(m.slice(1));
        return "([^/]+)";
      }) +
      "/?$",
  );
  routes.push({ pattern, keys, handler });
}

export function setNotFound(handler: RouteHandler): void {
  notFound = handler;
}

// Cleanups a view registers run once, right before the next navigation resolves
// (covers both pushState link nav and popstate). Lets views free resources —
// e.g. HLS instances, poll timers — without leaking across route changes.
let cleanups: Array<() => void> = [];
export function onRouteLeave(fn: () => void): void {
  cleanups.push(fn);
}

export function navigate(to: string): void {
  history.pushState({}, "", to);
  resolve();
}

export function resolve(): void {
  const root = document.getElementById("app");
  if (!root) return;
  const pending = cleanups;
  cleanups = [];
  for (const fn of pending) {
    try {
      fn();
    } catch {
      /* a failed cleanup must not block navigation */
    }
  }
  const path = location.pathname;
  for (const r of routes) {
    const m = r.pattern.exec(path);
    if (m) {
      const params: Record<string, string> = {};
      r.keys.forEach((k, i) => (params[k] = decodeURIComponent(m[i + 1] ?? "")));
      void r.handler(params, root);
      return;
    }
  }
  void notFound({}, root);
}

export function startRouter(): void {
  document.addEventListener("click", (e) => {
    const a = (e.target as HTMLElement).closest("a[data-link]");
    if (a instanceof HTMLAnchorElement && a.origin === location.origin) {
      e.preventDefault();
      navigate(a.pathname);
    }
  });
  window.addEventListener("popstate", resolve);
  resolve();
}
